import script from "./BButtonGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./BButtonGroup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__